/*------------------------------
{
"acf_fc_layout": "faq",
"collection": [
{
"title": "Dolorum nihil dolor ut et",
"content": "<p>Adipisci eos sint voluptas est vero minus quasi repudiandae. Et velit voluptatibus at laudantium libero voluptate. Totam dolor sit beatae eos aut qui ipsa.</p>\n<p>Praesentium eum labore inventore. Qui repellat est vero voluptatem placeat. Veritatis impedit est nisi quo corporis. Omnis omnis distinctio molestias soluta veniam soluta dolor rerum.</p>\n<p>Laudantium et distinctio nisi sequi occaecati occaecati magni. Modi ea saepe autem dolore expedita. Inventore aspernatur nam molestiae nostrum nihil. Aut quae velit eum architecto in est.</p>\n<p>Expedita autem eum impedit non. Quo et doloremque delectus optio. Quia hic vero voluptatem qui cum repellat. Modi non cumque dolorem aspernatur quaerat voluptatem aliquid.</p>\n<p>Facere molestiae quia veniam voluptatem eum. Dignissimos asperiores nobis quidem voluptatibus molestias consequuntur. Ut sit eos et quas. Ea inventore quidem enim unde rerum ut at.</p>\n",
"category": [
{
"id": 6,
"name": "Argomento 2",
"slug": "argomento-2"
}
]
}
------------------------------*/

import { useMemo, useRef, useState } from 'react'

import { removeParagraph } from '@/utils'

import AccordionGrid from './accordion-grid'
import Spacer from './spacer'
import TabsHeading from './tabs-heading'

export type FAQProps = {
  title?: string
  text?: string
  collection?: {
    title?: string
    content?: string
    category?: {
      id: number
      name: string
      slug: string
    }[]
  }[]
}

const FAQ = ({ title, text, collection }: FAQProps) => {
  const tabs = useRef<any>(null)
  const [selectedTab, setSelectedTab] = useState(0)
  const categories = useMemo(() => {
    const cats: { [key: string]: { id: number; name: string; slug: string } } = {}
    collection?.forEach((item) => {
      item.category?.forEach((cat) => {
        cats[cat.slug] = cat
      })
    })
    return Object.values(cats)
  }, [collection])

  const filteredCollection = useMemo(() => {
    const selectedCategory = categories[selectedTab]
    return collection?.filter((item) =>
      item.category?.some((cat) => cat.slug === selectedCategory.slug)
    )
  }, [collection, selectedTab, categories])

  const allTabs = categories.map((cat) => ({ label: cat.name }))

  const handleTabChange = (index: number) => {
    setSelectedTab(index)
  }

  return (
    <div>
      <TabsHeading
        ref={tabs}
        title={title}
        text={text}
        tabs={allTabs}
        onTabChange={handleTabChange}
        is_first={true}
      />
      <Spacer size="sm" />
      <AccordionGrid
        items={
          filteredCollection?.map((item) => ({
            header: item.title || '',
            content: removeParagraph(item.content) || '',
            actions: undefined
          })) || []
        }
      />
    </div>
  )
}

export default FAQ
